module.exports = __webpack_public_path__ + "img/blue_logo.b72c7d05.svg";